import { Reveal } from "../components/Reveal";
import { useLang } from "../lib/i18n";

export const StatsBar = () => {
  const { t } = useLang();
  return (
  <section data-testid="stats-bar-section" className="border-y border-edge/40 shadow-[0_1px_30px_rgba(24,21,16,0.07)]">
    <div className="mx-auto grid max-w-7xl grid-cols-1 sm:grid-cols-2">
      <Reveal className="border-b border-edge/40 px-6 py-10 sm:border-b-0 sm:border-r md:px-12 lg:px-20" testid="stat-clients">
        <p className="font-archivo text-5xl font-black tracking-tight text-amber md:text-6xl">50+</p>
        <p className="mt-3 font-mono text-xs uppercase tracking-[0.25em] text-tan">{t.statClients}</p>
        <p className="mt-2 text-xs text-[#181510]/75">{t.statClientsNote}</p>
      </Reveal>
      <Reveal delay={0.12} className="px-6 py-10 md:px-12 lg:px-20" testid="stat-reach">
        <p className="font-archivo text-5xl font-black tracking-tight text-amber md:text-6xl">500.000+</p>
        <p className="mt-3 font-mono text-xs uppercase tracking-[0.25em] text-tan">{t.statReach}</p>
        <p className="mt-2 text-xs text-[#181510]/75">{t.statReachNote}</p>
      </Reveal>
    </div>
  </section>
  );
};
